import "./header.js";
import "./menu.js";
import "./content.js";
import "./classes.js";
import "./class-detail.js";
import "./scoreboard.js";
import "./assignments.js";
import "./games.js";
import "./score.js";
import "./export.js";
import "./scores.js";
import "./engagement-weekly.js";
import "./activity.js";
import "./engagement.js";
import "./convert.js";
import "./create-assignment.js"
import "./roles.js";
import "./onboard.js";
import "./profile.js";
import "./my-time.js";
import "./my-xp.js";
import "./library.js";
import "./student-classes.js"
import "./student-class-detail.js"
import "./class-boards.js"
import "./pack-rules.js"
import "./class-xp.js"
import "./pack-units.js"
import "./skill-map.js"
import "./class-readiness.js"
import "./training.js"
import "./modules.js"
import "./reports.js"
import "./pane-settings.js"
import "./access.js"
import "./help-panel.js"

class AppShell extends HTMLElement {
   connectedCallback() {
      const role = this.getAttribute("data-role") || "student";
      const body = this.innerHTML; // capture page content

      this.innerHTML = `
         <app-header></app-header>
         <div class="shell">
            <app-menu role="${role}"></app-menu>
            <app-content>${body}</app-content>
         </div>`;

      addHelpPanels(this, role);
   }
}

/*
   Give every view its help panel from ONE place.

   Runs after the body has been re-inserted above, and prepends an <app-help> to
   each [data-view] block. app-help removes ITSELF when help-content.js has no
   entry for that view, so this loop deliberately does not filter: the content
   file stays the single place that decides which views have help.

   Prepending into the [data-view] wrapper rather than into the view COMPONENT
   is what keeps this out of the components entirely. The wrapper is plain
   markup owned by professor/admin/student.html; the component underneath is
   untouched and cannot be broken by this.
*/
function addHelpPanels(root, role) {
   root.querySelectorAll("[data-view]").forEach((block) => {
      const view = block.getAttribute("data-view");
      if (!view || block.querySelector(":scope > app-help")) return;
      const help = document.createElement("app-help");
      help.setAttribute("view", view);
      help.setAttribute("role", role);
      block.prepend(help);
   });
}

customElements.define("app-shell", AppShell);